import React from "react";
import { NavLink } from "react-router-dom";
import { MainStoryType } from "../core/lib/types";
import Auth from "../core/services/auth";
import { getVideoThumb } from "../core/lib/utils";

function MainStoryComponent({ vendor, stories, allStories }: MainStoryType) {
    //
    return (
            <li className="flex flex-col items-center space-y-1 relative">
                {/* <NavLink to="/story" state={story}>
                    <div className="bg-gradient-to-tr from-yellow-300 to-fuchsia-800 p-1 rounded-full">
                        <a className=" bg-white block rounded-full p-1 hover:-rotate-6 transform transition" href="#">
                            <img className="h-24 w-24 rounded-full" src={story.media.publicId} alt={story.caption} />
                        </a>
                    </div>
                    <a href="#">
                        {story.caption}
                    </a>
                </NavLink> */}
                <NavLink to="/story" state={{data: {
                    vendor,
                    stories,
                    allStories
                }}}>
                    {/* bg-gradient-to-tr from-yellow-300 to-fuchsia-800 | bg-gray-300*/}
                    <div style={{width: '75px'}} className={stories[0].viewedBy?.includes(Auth.getUser()._id) ? 'bg-gray-300 p-0.5 rounded-full' : 'bg-gradient-to-tr from-yellow-300 to-fuchsia-800   p-0.5 rounded-full'}>
                        <div style={{width:'70px', height: '70px'}} className=" bg-white rounded-full p-1">
                            {stories[0].media.type === 'image' ?
                              <img style={{ objectFit: 'cover', width:'62px', height: '62px'}} className="object-cover aspect-square rounded-full" src={stories[0].media.url+'#t=0.001'} alt={stories[0].caption} />
                              : 
                              stories[0].media.type === 'video' ?
                              <video  style={{ objectFit: 'cover',  width:'62px', height: '62px' }} poster={getVideoThumb(stories[0].media.url)} className="aspect-square object-cover rounded-full"> 
                                <source src={stories[0].media.url+'#t=0.001'} type='video/mp4'></source>
                                <source src={stories[0].media.url+'#t=0.001'} type='video/ogg'></source>
                              </video>
                              : 
                              ''
                            }
                        </div>
                    </div>
                    {/* <button className="absolute bottom-8 right-1 bg-purple-800 rounded-full h-8 w-8 text-2xl
                        text-white font-semibold border-2
                        border-white flex justify-center items-center font-mono hover:bg-blue-700">+</button> */}
                    <span className="text-xs font-light pt-1.5">
                        {vendor.name.length > 11 ? vendor.name.substring(0,12).concat(' ...') : vendor.name }
                    </span>
                </NavLink>
            </li>
    )
}

export default MainStoryComponent